routes.$inject = ['$stateProvider'];

export default function routes($stateProvider) {
  $stateProvider
    .state('swipe', {
      url: '/quick/match',
      template: require('./index.html'),
      controller: 'SwipeController',
      controllerAs: 'swipe',
      authRequired: true
    })
}



// WEBPACK FOOTER //
// ./src/app/features/swipe/routes.js